var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/user"}},[_vm._v("User")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/service"}},[_vm._v("Service")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }